import { NextPageContext } from 'next';
import Head from 'next/head';
import { generateCookieList } from 'common/utils/trackingTag';
import PortfolioPageContent from 'components/v2/modules/portfolio';
import { SITE_BASE_URL } from 'config/env';
import { parse } from 'cookie';

const title = 'PostPrime | デモ取引ポートフォリオ - 仮想投資で資産形成を学ぶ';
const description =
  'PostPrimeのデモ取引ポートフォリオで仮想投資を体験。高橋ダンが企画した投資学習プラットフォームで、リスクなしで株式取引の基本を学び、資産形成スキルを身につけましょう。';
const url = `${SITE_BASE_URL}/p/portfolio`;
export default function PortfolioPage(): JSX.Element {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta property="twitter:url" content={url} />
        <link rel="canonical" href={url} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="og:type" content="website" key="ogtype" />

        {/* Structured data for SEO */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              name: 'PostPrime',
              url: url,
              description: description,
            }),
          }}
        />
      </Head>
      <PortfolioPageContent />
    </>
  );
}

export const getServerSideProps = (context: NextPageContext) => {
  const cookiesList = generateCookieList(
    context.query,
    parse(context.req?.headers?.cookie || ''),
  );
  if (cookiesList.length > 0) {
    context.res.setHeader('Set-Cookie', cookiesList);
  }
  return {
    props: {},
  };
};
